import { urlAbsoluteToRelative3catinfo } from '@portal-internet/core';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import Icona from 'components/3catinfo/ui/Icona';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from './menuseo.module.scss';
import Enllac from 'components/3catinfo/Enllac/Enllac';
import Fila from 'components/3catinfo/Fila';

const _itemsDropdown = (items) => {
    return items.map((item, index) => {
        return (
            <li key={item.id} className={styles.item} data-testid={`menu-seo-item-${index}`}>
                <Enllac
                    href={urlAbsoluteToRelative3catinfo(item.url)}
                    titol={item.text}
                    className={styles.itemLink}
                    tabIndex={0}
                />
            </li>
        );
    });
};

const DropdownSeo = (props) => {
    const { items } = props;
    const [openDropdown, setOpenDropdown] = useState(false);
    const [hasOpenDropdown, setHasOpenDropdown] = useState(false);

    const label = 'Més';

    const refDropDown = useRef();
    const refDropper = useRef();
    const buttonDropDown = useRef();

    const stylesDropdown = clsx({
        [styles.wrapper]: true,
        [styles.open]: openDropdown
    });

    const _tancaMenu = (e) => {
        if (e.key === 'Escape') {
            setOpenDropdown(false);
        }
        if (e.key === 'Tab') {
            const focusableElem = Array.from(refDropDown.current.querySelectorAll("a, button, [tabindex]:not([tabindex='-1'])"));

            const lastFocusableElem = focusableElem[focusableElem.length - 1];
            if (document.activeElement === lastFocusableElem) {
                setOpenDropdown(false);
            }
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!refDropDown?.current?.contains(event.target)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside, { passive: true });
        document.addEventListener('touchstart', handleClickOutside, { passive: true });
        document.addEventListener('keydown', _tancaMenu);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('keydown', _tancaMenu);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refDropDown]);

    useEffect(() => {
        if (openDropdown) {
            refDropper.current.setAttribute('aria-expanded', true);
            setHasOpenDropdown(true);
        } else {
            if (hasOpenDropdown) {
                buttonDropDown.current.focus();
            }
            refDropper.current.setAttribute('aria-expanded', false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDropdown]);

    return (
        <div className={stylesDropdown} ref={refDropDown}>
            <button
                onClick={() => setOpenDropdown(!openDropdown)}
                className={styles.dropdown}
                aria-expanded={openDropdown}
                ref={buttonDropDown}
            >
                <span className={styles.dropdown_text}>{label}</span>
                <Icona
                    className={styles.drowpdown_icona}
                    icona='fletxa_simple_avall'
                    alt={openDropdown ? 'Tancar desplegable' : 'Mostrar més opcions'}
                    isBlanc={true}
                    mida={18}
                />
            </button>
            <div className={styles.dropWrapper} ref={refDropper} role='navigation' onClick={() => setOpenDropdown(false)}>
                <ul data-testid='dropdown'>{_itemsDropdown(items)}</ul>
            </div>
        </div>
    );
};

const MenuSeo = ({ itemsSeo }) => {
    const llistaRef = useRef();
    const dropRef = useRef();
    const itemsRef = useRef([]);

    const [visibleItems, setVisibleItems] = useState(itemsSeo);
    const [dropdownItems, setDropdownItems] = useState([]);
    const [visible, setVisible] = useState(false);

    const stylesContent = clsx({
        [styles.innerWrapper]: true,
        [styles.hidden]: !visible
    });

    const stylesMenuSeoBtn = clsx({
        [styles.menuSeo]: true
    });

    const update = useCallback(() => {
        const containerWidth = llistaRef.current ? llistaRef.current.clientWidth - 16 : 0;
        let totalWidth = 0;
        let listItems = [];
        let dropItems = [];

        if (itemsSeo && itemsSeo.length > 0) {
            for (let i = 0; i < itemsSeo.length; i++) {
                const item = itemsRef.current[i];
                if (!item) continue;
                let itemWidth = item.offsetWidth;
                if (totalWidth + itemWidth < containerWidth) {
                    listItems.push(itemsSeo[i]);
                    totalWidth += itemWidth;
                } else {
                    dropItems.push(itemsSeo[i]);
                    totalWidth += itemWidth;
                }
            }
        }

        if (listItems.length > 1) {
            const lastItem = listItems.pop();
            dropItems = [...new Set([lastItem, ...dropItems])];
        }

        if (dropRef.current && __isEmpty(dropItems)) {
            dropRef.current.setAttribute('style', 'display: none');
        }
        setVisibleItems(listItems);
        setDropdownItems(dropItems);
        setVisible(true);
    }, [itemsSeo]);

    useEffect(() => {
        let resizeTimeOut;

        update();

        let widthResize = document.documentElement.clientWidth;
        const handleResize = () => {
            if (document.documentElement.clientWidth !== widthResize) {
                clearTimeout(resizeTimeOut);
                setVisible(false);
                setVisibleItems(itemsSeo);
                setDropdownItems([]);
                resizeTimeOut = setTimeout(() => {
                    update();
                }, 200);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return !__isEmpty(itemsSeo) ? (
        <div className={styles.menuWrapper} id='menu-seo'>
            <Fila tipus='fixed' estil='block'>
                <div className={stylesContent}>
                    <div className={styles.titol}>
                        <span>És notícia:</span>
                    </div>
                    <ul ref={llistaRef} className={styles.llistaSeo} data-testid={`menu-seo`}>
                        {visibleItems.map((item, index) => {
                            return (
                                <li
                                    key={item.id}
                                    className={styles.item}
                                    data-testid={`menu-seo-item-${index}`}
                                    ref={(el) => {
                                        itemsRef.current[index] = el;
                                    }}
                                >
                                    <Enllac
                                        href={urlAbsoluteToRelative3catinfo(item.url)}
                                        titol={item.text}
                                        className={styles.itemLink}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                    <div className={stylesMenuSeoBtn} ref={dropRef}>
                        <DropdownSeo items={dropdownItems} />
                    </div>
                </div>
            </Fila>
        </div>
    ) : null;
};

export default React.memo(MenuSeo);
